import Vue from "vue";

const AGENT_ORIGIN = "https://agents.eleventickets.com";
const AGENT_URL = `${AGENT_ORIGIN}/chat/cc3ee296-a62e-4b49-9d21-f72f0bbd786f`;

// só existe a versão pt-br da imagem desktop no S3
const imgSrc = "https://tourmaracana.s3.amazonaws.com/ajuda-cliente-pt-br.webp";
const mobile = "https://tourmaracana.s3.amazonaws.com/ajuda-cliente-mobile.webp";

export const deskManager = {
    // contexto enviado ao agente (bufferizado até o chat abrir e o iframe sinalizar "ready")
    context: {},
    aiReady: false,

    setContext(partial) {
        Object.assign(this.context, partial);
        this.sendContext();
    },
    sendContext() {
        const iframe = document.querySelector("#dwhatDiv iframe");
        if (!this.aiReady || !iframe || !iframe.contentWindow) return;

        const session = Vue.prototype.$axios.getLocal("session");
        const usuario = session && typeof session.data === "object" ? session.data : {};
        const context = {
            ...this.context,
            pagina: window.location.pathname + window.location.search,
            nome: usuario.nome,
            email: usuario.email,
            idioma: Vue.prototype.$lang_.getLang().lang,
        };
        iframe.contentWindow.postMessage({ source: "imply-widget-host", type: "setContext", context }, AGENT_ORIGIN);
    },
    setChatVisible(visible) {
        const chatWindow = document.getElementById("dwhatDiv");
        const chatIcon = document.getElementById("dwhats");
        if (chatWindow) chatWindow.style.display = visible ? "block" : "none";
        if (chatIcon) {
            chatIcon.classList.toggle("dwhatC", visible);
            chatIcon.classList.toggle("dwhatO", !visible);
        }
    },
    dwhatToggle() {
        const chatWindow = document.getElementById("dwhatDiv");

        if (chatWindow) {
            const visible = chatWindow.style.display === "none";
            this.setChatVisible(visible);
            // reenvia ao abrir, o usuário pode ter logado com o chat fechado
            if (visible) this.sendContext();
            return;
        }

        const newChatWindow = document.createElement("div");
        newChatWindow.id = "dwhatDiv";
        newChatWindow.style = "border-radius: 8px; position: fixed; border: 1px solid #ccc; width: 400px; bottom: 168px; height: 500px; right: 10px; max-width: 94%; max-height: calc(100% - 188px); z-index: 99 !important; background: white; overflow: hidden;";

        const chatIframe = document.createElement("iframe");
        chatIframe.src = AGENT_URL;
        chatIframe.title = "SAC";
        chatIframe.allow = "camera *; microphone *";
        chatIframe.style = "width: 100%; height: 100%; border: none;";

        // iframe novo (o menu mobile remove o antigo): espera o "ready" dele
        this.aiReady = false;
        newChatWindow.appendChild(chatIframe);
        document.body.appendChild(newChatWindow);
        this.setChatVisible(true);

        // escuta o "ready" e o "minimizar" enviados de dentro do iframe do chat (widget Imply)
        if (!window.__implyMinimizeListener) {
            window.__implyMinimizeListener = true;
            window.addEventListener("message", (e) => {
                if (e.origin !== AGENT_ORIGIN) return;
                if (!e.data || e.data.source !== "imply-widget") return;

                if (e.data.type === "ready") {
                    this.aiReady = true;
                    this.sendContext();
                } else if (e.data.type === "minimize") {
                    this.setChatVisible(false);
                }
            });
        }
    },
    dwhatLoad() {
        var e = document.createElement("style");
        (e.innerHTML = `.dwhatC::before{background:url(${imgSrc})top center no-repeat;background-size: cover;}.dwhatO::before{background:url(${imgSrc})top
			center no-repeat;background-size: cover;}#dwhats{width:168px;height:106px;display:block;cursor: pointer;}
            @media(max-width:958px){#dwhats{width:120px;height: 120px;}.dwhatO::before{background:url(${mobile})top
			center no-repeat;background-size: cover;}.dwhatC::before{background:url(${mobile})top center no-repeat;background-size: cover;}}
            #dwhats{position:fixed;bottom:48px;z-index:10;display:flex;align-items:center;right:15px;}
			#dwhats::before{content:\"\";width:100%;height:100%;display: block;}`),
            document.head.appendChild(e);
        let link = document.createElement("a");
        link.addEventListener("click", () => {
            this.dwhatToggle();
        });
        (link.id = "dwhats"),
            (link.className = "dwhatO"),
            link.classList.add("animate__animated", "animate__fadeInUp");
        document.body.appendChild(link);
    },
};
